import Head from 'next/head';
import Router, { useRouter } from 'next/router';
// import NotFound from '../NotFound/index.page';
// import Success from '../Success/index.page';
import styles from './styles.module.css';
import { getUrls } from '../../../../services/wl/getUrls';
// import FormFornecedor from '../FormFornecedor';
// import SemConsumoMinimo from '../SemConsumoMinimo/index.page';
// import NotFoundPlan from '../NotFoundPlan/index.page';
import FormNovaJornada from '../FormNovaJornada';
import Iframe from '../Iframe';
const CardForm = (props) => {
  const router = useRouter();
  
  const {
    app, // Identifica layout da página: Está no WebApp? 1-> SIM | Null ou != 1 -> Iframe
    owner: ownerID, // Usado para identificar a campanha
    type: queryType, // Modelo de exibição (Tela de Formulário, Tela de Sucesso, Etc)
    ...query // restante das propriedades
  } = router.query;
  
  const allQueryParams = Object.keys(query).map(key => ({ key, value: query[key] }));
  const isApp = props.isApp;
  
  const extraFields = allQueryParams.filter(
    item => item.key
      .toLowerCase()
      .startsWith("ef_")
  );
  
  // Tipos de Form Gerenciados
  const formTypes = {
    'success': 'success',
    'not-found': 'not-found',
    'form': 'form',
    'form-fornecedor': 'form-fornecedor',
    'sem-consumo-minimo': 'sem-consumo-minimo',
    'not-found-plan': 'not-found-plan',
    'waiting': 'waiting',
  };

  const type = formTypes[queryType] ?? 'waiting';

  const imgCardLeft = getUrls(props.wl?.card_esquerda?.data?.attributes?.url);
  const imgSplash = getUrls(props.wl?.splash?.data?.attributes?.url);

  return (
    <>
      {!!!props.full ? (
        <Head>
          <link rel="stylesheet" href="/css/calculadora.css" />
        </Head>
      ) : (
        ''
      )}
      <section
        className={`${styles.container} ${props.full ? styles.full : ''}`}
      >
        <article className={styles['card-left']}>
          <img src={imgCardLeft} alt={props.wl?.empresa} />
        </article>

        {
          app == 1 ? (

            <article className={styles['card-rigth']}>
              {
                // Incluir ternários para checar se é >> success / form / not-found <<
                type == 'waiting' ? (
                  <img className={styles.logo} src={imgSplash} />
                ) : (
                   <FormNovaJornada
                      owner={ownerID}
                      full={props.full}
                      isApp={isApp}
                      wl={props.wl}
                      infos={props.infos}
                      extraFields={extraFields}
                    />
                )
              }
              <div
                className={styles.bottomBorderExternal}
                style={{
                  background: props.wl?.cor_ponta_inferior_lateral_esquerda,
                }}
              >
                <div className={styles.bottomBorderInternal}></div>
              </div>

              {isApp && props.wl?.empresa === 'ELECTY' ? (
                <>
                  <img
                    className={styles.fio1}
                    src="/images/calculadora-desconto/components/Form/fio-01.svg"
                    alt="no-img"
                  />
                  <img
                    className={styles.fio2}
                    src="/images/calculadora-desconto/components/Form/fio-02.svg"
                    alt="no-img"
                  />
                </>
              ) : (
                ''
              )}
              {props.wl.Calculadora.habilitar_captura_fornecedor &&
                queryType === 'form' && (
                  <div
                    className={styles.cardFornecedor}
                    style={{
                      background: props.wl.cor_tema_4,
                    }}
                  >
                    <button
                      onClick={() =>
                        Router.push(
                          `/calculadora-desconto?type=form-fornecedor&${
                            app && 'app=1'
                          }`
                        )
                      }
                    >
                      {props.wl.Calculadora.texto_captura_fornecedor}
                    </button>
                  </div>
                )}
            </article>
          ) : (
            <article className={styles['card-iframe']}>
              {
                // Incluir ternários para checar se é >> success / form / not-found <<
                type == 'waiting' ? (
                  <img className={styles.logo} src={imgSplash} />
                ) : (

                  <Iframe    
                    owner={ownerID}
                    full={props.full}
                    isApp={isApp}
                    wl={props.wl}
                    infos={props.infos}
                    extraFields={extraFields}/>
                )
              }
              <div
                className={styles.bottomBorderExternal}
                style={{
                  background: props.wl?.cor_ponta_inferior_lateral_esquerda,
                }}
              >
                <div className={styles.bottomBorderInternal}></div>
              </div>

              {isApp && props.wl?.empresa === 'ELECTY' ? (
                <>
                  <img
                    className={styles.fio1}
                    src="/images/calculadora-desconto/components/Form/fio-01.svg"
                    alt="no-img"
                  />
                  <img
                    className={styles.fio2}
                    src="/images/calculadora-desconto/components/Form/fio-02.svg"
                    alt="no-img"
                  />
                </>
              ) : (
                ''
              )}
              {props.wl.Calculadora.habilitar_captura_fornecedor &&
                queryType === 'form' && (
                  <div
                    className={styles.cardFornecedor}
                    style={{
                      background: props.wl.cor_tema_4,
                    }}
                  >
                    <button
                      onClick={() =>
                        Router.push(
                          `/calculadora-desconto?type=form-fornecedor&${
                            app && 'app=1'
                          }`
                        )
                      }
                    >
                      {props.wl.Calculadora.texto_captura_fornecedor}
                    </button>
                  </div>
                )}
            </article>

          )
        }
      </section>
    </>
  );
};

export default CardForm;
